import { render, staticRenderFns } from "./BenefitsList2.vue?vue&type=template&id=2f57a630&"
import script from "./BenefitsList2.vue?vue&type=script&lang=js&"
export * from "./BenefitsList2.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsList2.vue?vue&type=style&index=0&id=2f57a630&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports